/** 请求装饰器类型枚举 */
export enum RequestDecoratorEnum {
  /** 请求参数装饰 */
  REQUEST_PARAMS = '01',
  /** 请求请求装饰 */
  REQUEST_TIMESTAMPS = '02'
}
